import { create } from 'zustand';

type verifyState = {
  tryed: boolean;
  verify: boolean;
  setTryed: (data: boolean) => void;
  setVerifyData: (data: boolean) => void;
};

export const useVerifyDataStore = create<verifyState>((set, get) => ({
  tryed: false,
  setTryed: data => set(() => ({ tryed: data })),
  verify: false,
  setVerifyData: data => set(() => ({ verify: data })),
  action: () => {
    const data = get().verify;
  },
}));
